webpackJsonp([13509116309915],{

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/accomodations1.dddd0ffb.jpg";

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/accomodations2.e1dd12b5.jpg";

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/accomodations3.794c7d23.jpg";

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _accomodations = __webpack_require__(447);
	
	var _accomodations2 = _interopRequireDefault(_accomodations);
	
	var _accomodations3 = __webpack_require__(448);
	
	var _accomodations4 = _interopRequireDefault(_accomodations3);
	
	var _accomodations5 = __webpack_require__(449);
	
	var _accomodations6 = _interopRequireDefault(_accomodations5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocationPage = function LocationPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'post' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'title' },
	      'Accomodations'
	    ),
	    _react2.default.createElement(
	      'center',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'center',
	          null,
	          _react2.default.createElement(
	            'table',
	            { cellPadding: '0', cellSpacing: '5' },
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement('img', { src: _accomodations2.default, style: { maxWidth: 386 } })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement('img', { src: _accomodations4.default, style: { maxWidth: 386 } })
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement('img', { src: _accomodations6.default, style: { maxWidth: 386 } })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      { className: 'title' },
	      'Location'
	    ),
	    _react2.default.createElement(
	      'center',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('iframe', {
	          width: '425',
	          height: '350',
	          frameBorder: '0',
	          scrolling: 'no',
	          marginHeight: '0',
	          marginWidth: '0',
	          src: 'https://www.google.com/maps?f=d&source=s_d&saddr=Salt+Lake+International+Airport,+Salt+Lake+City,+UT&daddr=holden,+utah&hl=en&geocode=FQRbbgIdj1FT-SEZSFn1JkMfbynp9Ndni_NShzEZSFn1JkMfbw%3BFeOZVAIdTeJO-SlFjraEcaBMhzHQA3sI9M5TQA&aq=t&sll=39.943436,-111.923218&sspn=3.516322,7.13562&mra=ls&ie=UTF8&t=m&ll=39.942655,-111.958795&spn=1.68761,0.62429&output=embed'
	        }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'small',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.google.com/maps?f=d&source=embed&saddr=Salt+Lake+International+Airport,+Salt+Lake+City,+UT&daddr=holden,+utah&hl=en&geocode=FQRbbgIdj1FT-SEZSFn1JkMfbynp9Ndni_NShzEZSFn1JkMfbw%3BFeOZVAIdTeJO-SlFjraEcaBMhzHQA3sI9M5TQA&aq=t&sll=39.943436,-111.923218&sspn=3.516322,7.13562&mra=ls&ie=UTF8&t=m&ll=39.942655,-111.958795&spn=1.68761,0.62429',
	              style: { color: '#0000FF', textAlign: 'left' }
	            },
	            'View Larger Map'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = LocationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-location-js-ca781579061025bab38a.js